import styles from './styles.module.scss';
import Layout from '@layout/index';
import Button from '@components/button';

const { container, calculators_grid, calculator_card, calculator_header, calculator_content } =
  styles;

const CalculatorsPage = ({ fixtures }) => {
  const calculatorData = fixtures || {
    mortgage: {
      name: 'Mortgage Calculator',
      description: 'Calculate your monthly mortgage payments.'
    },
    affordability: {
      name: 'Affordability Calculator',
      description: 'Determine how much house you can afford.'
    },
    refinance: {
      name: 'Refinance Calculator',
      description: 'See if refinancing your mortgage makes sense.'
    }
  };

  return (
    <Layout>
      <div className={container}>
        <div className={calculator_header}>
          <h1>Calculators</h1>
          <p>Find the right calculator for your needs.</p>
        </div>

        <div className={calculators_grid}>
          {Object.entries(calculatorData).map(([key, calculator]) => (
            <div key={key} className={calculator_card}>
              <div className={calculator_content}>
                <h3>{calculator.name}</h3>
                <p>{calculator.description}</p>
                <Button label="Use Calculator" url={`/calculators/${key}`} theme="red" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default CalculatorsPage;
